import { Component, OnInit } from '@angular/core';
import { AdminService } from '../services/admin.service';
import Chart from 'chart.js/auto';
import { firstValueFrom } from 'rxjs';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-adm-dashboard',
  templateUrl: './adm-dashboard.component.html',
  styleUrls: ['./adm-dashboard.component.css']
})
export class AdmDashboardComponent implements OnInit {
  loadPage = false;
  numeroVacantes;
  salarioPromedio;
  top3;
  postulaciones;
  postulacionGenero;

  topHabilidades;
  topConocimientos;
  comparative;

  contador = 0;
  constructor(private adminService:AdminService,
            private toast : ToastrService){}

  async ngOnInit() {
    await this.loadData();
    await this.loadTops();
    await this.loadComparative();
  }

  createHabilidadesBarChart()
  {
    const canvas = document.getElementById('habilidades') as HTMLCanvasElement;
    new Chart(
      canvas,
      {
        type: 'bar',
        data: {
          labels: this.topHabilidades.map(row => row.habilidad),
          datasets: [
            {
              label: 'Habilidades socioemocionales más solicitadas',
              data: this.topHabilidades.map(row => row.conteo),
              backgroundColor: [
                'rgba(255, 99, 132, 0.2)',
                'rgba(255, 159, 64, 0.2)',
                'rgba(255, 205, 86, 0.2)',
                'rgba(75, 192, 192, 0.2)',
                'rgba(54, 162, 235, 0.2)',
                'rgba(153, 102, 255, 0.2)',
                'rgba(201, 203, 207, 0.2)'
              ],
              borderColor: [
                'rgb(255, 99, 132)',
                'rgb(255, 159, 64)',
                'rgb(255, 205, 86)',
                'rgb(75, 192, 192)',
                'rgb(54, 162, 235)',
                'rgb(153, 102, 255)',
                'rgb(201, 203, 207)'
              ],
              borderWidth: 1
            }
          ],
          
        },
        
      }
    );
  }

  async loadEgresadosTrabajando() : Promise<boolean>
  {
    try {
      const data = await firstValueFrom(this.adminService.dashEgresadosTrabajando());
      if(!data)
        return false;
      this.contador = data.contador;
      return true;
    } catch (error) {
      return false;
    }
  }


  dispersion()
  {
    const canvas = document.getElementById('comparative') as HTMLCanvasElement;
    const data = {
      labels:  this.comparative.map(row => row.area),
      datasets: [
        {
          label: "Sueldo Mínimo Promedio",
          data: this.comparative.map(row => row.sueldoMinPromedio),
          borderColor: 'rgb(255, 99, 132)',
          backgroundColor: 'rgba(201, 203, 207, 0.2)',
          fill: true
        },
        {
          label: "Sueldo Máximo Promedio",
          data: this.comparative.map(row => row.sueldoMaxPromedio),
          borderColor:'rgb(75, 192, 192)',
          backgroundColor: 'rgba(255, 205, 86, 0.2)',
          fill: true
        },
      ]
    };
  
    var dispersionChart = new Chart(canvas, {
      type: 'line',
      data: data,
      options: {
        plugins: {
          filler: {
            propagate: false,
          },
          title: {
            display: true,
            text: 'Comparación de sueldos promedio por área'
          }
        }
      },
    });
  }


  createConocimientosBarChart()
  {
    const canvas = document.getElementById('conocimientos') as HTMLCanvasElement;
    new Chart(
      canvas,
      {
        type: 'bar',
        data: {
          labels: this.topConocimientos.map(row => row.conocimiento),
          datasets: [
            {
              label: 'Habilidades técnicas más solicitados',
              data: this.topConocimientos.map(row => row.conteo),
              backgroundColor: [
                'rgba(255, 99, 132, 0.2)',
                'rgba(255, 159, 64, 0.2)',
                'rgba(255, 205, 86, 0.2)',
                'rgba(75, 192, 192, 0.2)',
                'rgba(54, 162, 235, 0.2)',
                'rgba(153, 102, 255, 0.2)',
                'rgba(201, 203, 207, 0.2)'
              ],
              borderColor: [
                'rgb(255, 99, 132)',
                'rgb(255, 159, 64)',
                'rgb(255, 205, 86)',
                'rgb(75, 192, 192)',
                'rgb(54, 162, 235)',
                'rgb(153, 102, 255)',
                'rgb(201, 203, 207)'
              ],
              borderWidth: 1
            }
          ],
          
        },
        
      }
    );
  }

  async loadComparative(): Promise<boolean>
  {
    try {
      this.comparative = await firstValueFrom(this.adminService.dashComparacionSueldoArea());
      if(!this.comparative)
        return false;
      this.dispersion();
      return true;
    } catch (error) {
      this.toast.error('No se pudo cargar la información');
    }
  }

  async loadTops() : Promise<boolean>
  {
    try {
      this.topHabilidades = await firstValueFrom(this.adminService.dashGetTopHabilidadeds());
      this.topConocimientos = await firstValueFrom(this.adminService.dashGetTopConocimientos());
      if(!this.topHabilidades || !this.topConocimientos)
        return false;
      this.createHabilidadesBarChart();
      this.createConocimientosBarChart();
      return true;
    } catch (error) {
      this.toast.error('No se pudo cargar la información');
    }
  }


  async loadData()
  {
    let Data1 = await this.getVacantes();
    let Data2 = await this.getSalario();
    let Data3 = await this.getTopAreas();
    let Data4 = await this.getAvgPostulacion();
    let Data5 = await this.getAvgPostulacionGenero();
    let Data6 = await this.loadEgresadosTrabajando();

    if(!Data1 || !Data2 || !Data3 || !Data4 || !Data5 || !Data6)
    {
      this.toast.info('No se cargo la información correctamente');
      return;
    }
    this.loadPage = true;
  }


  async getVacantes() : Promise<boolean>
  {
    try {
      var result = await firstValueFrom(this.adminService.dashGetVacantes());
      if(!result)
        return false;
      this.numeroVacantes=result;
      return true;
      
    } catch (error) {
      return false;
    }
  }

  async getSalario() : Promise<boolean>
  {
    try {
      var result = await firstValueFrom(this.adminService.dashGetSalario());
      if(!result)
        return false;
      this.salarioPromedio=parseFloat(result.promedio_salario.toFixed(2));
      return true;
      
    } catch (error) {
      return false;
    }
  }

  async getTopAreas() : Promise<boolean>
  {
    try {
      var result = await firstValueFrom(this.adminService.dashGetTopAreas());
      if(!result)
        return false;
      this.top3=result;
      return true;
      
    } catch (error) {
      return false;
    }
  }

  async getAvgPostulacion() : Promise<boolean>
  {
    try {
      var result = await firstValueFrom(this.adminService.dashGetPostulacionAvg());
      if(!result)
        return false;
      this.postulaciones=result;
      return true;
      
    } catch (error) {
      return false;
    }
  }

  async getAvgPostulacionGenero() : Promise<boolean>
  {
    try {
      var result = await firstValueFrom(this.adminService.dashGetPostulacionGeneroAvg());
      if(!result)
        return false;
      result.forEach(element=>
        {
          if(element.descripcion==='Mujer')
            element.descripcion='Mujeres';
          if(element.descripcion==='Hombre')
            element.descripcion='Hombres';
          element.porcentaje = parseFloat(element.porcentaje.toFixed(2));
        });
      this.postulacionGenero=result;
      return true;
      
    } catch (error) {
      return false;
    }
  }
  
}
